import CardDiscount from '../../../../../layouts/Card/cardContent/CardDiscount';

export const listSettings = {
    grid : {
        components : CardDiscount,
        columns : {
            xs : 1,
            sm : 2,
            md: 2,
            laptop : 3,
        }
    },
}

export const listMappers = [
    {
        view : 'card',
        mapper : null
    },
    // {
    //     view : 'table',
    //     mapper : 'companiesListMapper'
    // }
]

export const perPageOptions = {
    'card' : ['6', '24', '36'],
}